import React from "react";
import { useNavigate } from "react-router-dom";

import { useAppSelector } from "../../../../app/hooks";

import "./ReportsWidget.scss";

export const ReportsWidget: React.FC = () => {
  const navigate = useNavigate();

  const user = useAppSelector((state) => state.auth.user);
  const showFinancialReports =
    user &&
    ["joe.cene@triplepdisposal.com", "milicevic_pz@wvwc.edu"].includes(
      user.email,
    );

  const handleDailyReportClick = () => navigate("/reports/daily");
  const handleYearlyReportClick = () =>
    showFinancialReports && navigate("/reports/yearly");
  const handleProfitReportClick = () => navigate("/reports/profit");
  const handleOwesReportClick = () => navigate("/reports/owes");
  const isProd = process.env.REACT_APP_ENVIRONMENT === "production";
  const handleHGEOwesReportClick = () => navigate("/reports/hge-owes");
  const handleSmartRoofOwesReportClick = () =>
    navigate("/reports/smartroof-owes");
  const handleTransactionsReportClick = () => navigate("/reports/transactions");

  return (
    <div className="reports-widget-component">
      <div className="title">Reports</div>

      <div className="reports-links-container">
        <div className="column">
          <div className="link" onClick={handleDailyReportClick}>
            Daily report
          </div>

          <div className="link" onClick={handleOwesReportClick}>
            Owes report
          </div>

          {isProd && (
            <div className="link" onClick={handleHGEOwesReportClick}>
              HGE Owes report
            </div>
          )}

          {isProd && (
            <div className="link" onClick={handleSmartRoofOwesReportClick}>
              SmartRoof Owes report
            </div>
          )}

          <div className="link" onClick={handleTransactionsReportClick}>
            Stax report
          </div>
        </div>

        <div className="column">
          {showFinancialReports && (
            <div className="link" onClick={handleYearlyReportClick}>
              Yearly report
            </div>
          )}

          {showFinancialReports && (
            <div className="link" onClick={handleProfitReportClick}>
              Profit report
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
